import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-purchase-item-preloader',
    templateUrl: './purchase-item-preloader.component.html',
    styleUrls: ['./purchase-item-preloader.component.scss'],
    standalone: true
})
export class PurchaseItemPreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
